<template>
  <div class="Notice">
    <div class="text">
      <slot />
    </div>
    <Icon
      v-if="isClosable"
      class="close"
      name="cross"
      @click="$emit('close')" />
  </div>
</template>

<script>
// NOTE: can be rewritten as functional
export default {
  props: {
    theme: {
      default: 'info',
      type: String,
    },
    isClosable: Boolean,
  },
}
</script>

<style lang="scss">
.Notice {
  background: $neutral;
  color: $text-color-mid;
  font-weight: $semibold;
  margin-bottom: 1rem;
  padding: 1rem;
  position: relative;
  text-align: center;

  > .close {
    cursor: pointer;
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  .Btn {
    margin-right: 0.25rem;
  }

  &.alt {
    background: transparent;
    border-left: 4px solid $main;
    font-weight: $medium;
    text-align: left;
  }

  &.danger {
    background: $danger-lighter;
    color: $danger;
  }

  &.info {
    background: $info-lighter;
    color: $info;
  }
  // &.neutral {
  //   background: $neutral-lighter;
  //   color: $neutral;
  // }
  &.warning {
    background: $warning-lighter;
    color: $warning-dark;
  }

  &.success {
    background: $success-lighter;
    color: $success-dark;
  }

  &.fancy {
    background: $fancy-lighter;
    color: $fancy;
  }
}
</style>
